<template>
  <div class="common-tabs">
    <div
      class="tab"
      @click="handleChangeTab()"
      :key="activeLabel"
      :class="{ active: activeTabName === activeMenuName }"
    >
      {{ $t(activeLabel || '新建舱单') }}
    </div>
    <template v-if="currentTabs && currentTabs.length">
      <div
        class="tab"
        :class="{
          active: item.key === activeTabName && item.route.name === route.name,
        }"
        v-for="item in currentTabs"
        :key="item.key"
        @click="handleChangeTab(item)"
      >
        <span class="truncate">{{
          $t(item?.route?.meta?.title || 'tab.new')
        }}</span>

        <el-icon
          class="ml-6px text-#C2C6D1 cursor-pointer hover:text-#7a8689 hover:bg-#e5e7eb"
          name="icon-base-close-s"
          size="16px"
          @click.stop="handleRemoveTab(item)"
        ></el-icon>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import useMenu from '@/hooks/useMenu'
import useTabs from '@/hooks/useTabs'
// import { useMitt } from '@/hooks/useMitt'
// const emitter = useMitt()

const { activeMenuName, activeLabel } = useMenu()
const { currentTabs, activeTabName, removeTab, changeTab } = useTabs()
const route = useRoute()
const props = defineProps({
  beforeChange: {
    type: Function,
    default: () => {
      return true
    },
  },
  afterChange: {
    type: Function,
    default: () => {
      return true
    },
  },
  beforeRemove: {
    type: Function,
    default: () => {
      return true
    },
  },
  afterRemove: {
    type: Function,
    default: () => {
      return true
    },
  },
})
const emits = defineEmits(['removeTab'])
const handleRemoveTab = (item: any) => {
  if (['Detail', 'AI'].includes(item.route.name)) {
    if (route.name !== item.route.name) {
      // emitter.emit('removeTab')
      // handleChangeTab(item)
      removeTab({
        key: item.key,
        name: item?.route.name,
        beforeRemove: props.beforeRemove as () => any,
        afterRemove: props.afterRemove as () => any,
      })
    } else {
      emits('removeTab')
      // emitter.emit('removeTab')
    }
  } else {
    removeTab({
      key: item?.key,
      name: item?.route.name,
      beforeRemove: props.beforeRemove as () => any,
      afterRemove: props.afterRemove as () => any,
    })
  }
}
const handleChangeTab = (item?: any) => {
  changeTab({
    key: item?.key,
    name: item?.route?.name,
    beforeChange: props.beforeChange as () => any,
    afterChange: props.afterChange as () => any,
  })
}
</script>

<style lang="scss">
.common-tabs {
  display: flex;
  justify-content: flex-start;
  background: #fff;
  flex-wrap: wrap;
  .tab {
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #fff;
    color: #4b5669;
    font-weight: 400;
    font-size: 12px;
    border: 1px solid #e5e7eb;
    padding: 0 12px;
    min-width: 80px;
    max-width: 162px;
    border-right: none;
    border-top: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: 1px solid #e5e7eb;
    }
    &:hover {
      background: #f2f3f5 !important;
    }
    &.active {
      border-bottom: none;
      background: #f2f3f5;
      color: #1d2129;
      font-weight: 600;
    }
  }
}
</style>
